<template>
  <div>
    <router-link class="btn btn-info m-2" :to="`/dashboard/charges`">
      Back to Charge List
    </router-link>
    <card class="card">
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-6">
              <label for="inlineFormInput">Product</label>
              <select class="form-control" v-model="charge.product">
                <option value="withdrawal">Withdrawal</option>
                <option value="ikedc">Ikedc</option>
                <option value="ekedc">Ekedc</option>
                <option value="eedc">Eedc</option>
                <option value="ibedc">Ibedc</option>
                <option value="phedc">Phedc</option>
                <option value="aedc">Aedc</option>
                <option value="kedco">Kedco</option>
                <option value="mtnvtu">Mtnvtu</option>
                <option value="airtelvtu">Airtelvtu</option>
                <option value="9mobilevtu">9mobilevtu</option>
                <option value="glovtu">Glovtu</option>
                <option value="mtndata">Mtndata</option>
                <option value="glodata">Glodata</option>
                <option value="airteldata">Airteldata</option>
                <option value="9mobiledata">9mobiledata</option>
                <option value="multichoice">Multichoice</option>
                <option value="startimes">Startimes</option>
                <option value="smile">Smile</option>
                <option value="transfer">Transfer</option>
                <option value="sms">SMS</option>
                <option value="PAY_WITH_TRANSFER">PAY WITH TRANSFER</option>
                <option value="ZEEP_AND_GO">ZEEP AND GO</option>
              </select>
            </div>

            <div class="col-md-6">
              <fg-input
                type="number"
                label="Fee"
                placeholder="Charge Fee Amount"
                v-model="charge.fee"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label for="inlineFormInput">Type</label>
              <select class="form-control" v-model="charge.type">
                <option value="charge">charge</option>
                <option value="commission">Commission</option>
                <option value="tax">Tax</option>
              </select>
            </div>

            <div class="col-md-6">
              <label for="inlineFormInput">Mode</label>
              <select class="form-control" v-model="charge.mode">
                <option value="fixed">Fixed</option>
                <option value="percentage">Percentage</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="number"
                label="Minimum Amount"
                placeholder="Min Amount"
                v-model="charge.minAmount"
              >
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input
                type="number"
                label="Maximum Amount"
                placeholder="Max Amount"
                v-model="charge.maxAmount"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label>Agent Category</label>
              <multiselect
                v-model="selectedMerchant"
                :custom-label="optionLabel"
                track-by="_id"
                :options="utils.merchants"
                :allow-empty="false"
                placeholder="Select an Agent Category"
                @close="getAgents"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  {{ option.merchantName }}
                </template>
              </multiselect>
            </div>

            <div class="col-md-6">
              <fg-input
                type="number"
                label="VAT on fee"
                placeholder="VAT"
                v-model="charge.vat"
              >
              </fg-input>
            </div>
          </div>

          <div class="row" v-if="charge.mode === 'fixed'">
            <div class="col-md-6">
              <fg-input
                type="number"
                label="Total Fee"
                placeholder="Total Fee"
                :value="totalFee"
                disabled
              >
              </fg-input>
            </div>
          </div>

          <div class="text-center">
            <p-button type="info" round @click.native.prevent="submit">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Create
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      selectedMerchant: "",
      charge: {},
      selectedMode: "",
    };
  },
  computed: {
    ...mapState(["loading", "terminal", "utils", "auth"]),
    totalFee() {
      const fee = Number(this.charge.fee);
      const vat = Number(this.charge.vat);
      return fee + fee * (vat / 100);
    },
  },
  methods: {
    ...mapActions(["saveCharges", "getMerchants"]),
    submit() {
      if (this.selectedMerchant !== "") {
        this.charge.merchantId = this.selectedMerchant._id;
      }
      this.$confirm("Save Charges?").then(() => {
        this.saveCharges(this.charge);
      });
    },
    optionLabel({ merchantName, state, country }) {
      return `${merchantName}, ${state}, ${country}`;
    },
  },
  mounted() {
    if (this.auth.user.userType === "super-admin") {
      this.getMerchants();
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
